import { Box, IconButton, Stack, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../components/TableContent';
import { TableHeadContainer, TableHeadItem } from '../../../../components/TableHead';
import { IOProductItem } from '../../../../store/customerDetail/SecuritiesTransfer/types';

import { DynamicIOProductTableLayoutProps } from './types';

export const ItemSeparator: React.FC = () => (
  <Box
    height={Utils.Responsive.PhoneTablet({
      phone: 'stack.xxxs',
      tablet: 'stack.nano',
    })}
  />
);

export const DynamicIOProductTableDesktop = <T extends IOProductItem>({
  title,
  titleDataKey,
  data,
  columns,
  keyExtractor,
  onPressItem,
  renderTitle,
  renderColumnValue,
  renderTitleValue,
}: DynamicIOProductTableLayoutProps<T>) => {
  return (
    <VStack space="stack.nano" pt="stack.xxs">
      <Stack>
        <TableHeadContainer>
          <TableHeadItem title={title} flex={1} />
          {columns.map((column, index) => (
            <TableHeadItem maxW="12%" key={`${column.title}-${index}`} title={column.title} />
          ))}
          {onPressItem && <TableHeadItem title="" maxW="inline.xs" />}
        </TableHeadContainer>
      </Stack>

      <VStack>
        {data.map((item, index) => (
          <Box key={keyExtractor(item, index)}>
            {index > 0 && <ItemSeparator />}

            <TableContent direction="row" space={0}>
              <TableContentItemColumn flex={1}>
                {renderTitleValue(item, titleDataKey, renderTitle, false)}
              </TableContentItemColumn>

              {columns.map((column, columnIndex) => (
                <TableContentItemColumn key={`${String(column.dataKey)}-${columnIndex}`} maxW="12%">
                  {renderColumnValue(item, column, false)}
                </TableContentItemColumn>
              ))}

              {!!onPressItem && (
                <TableContentItemColumn alignItems="flex-end" maxW="inline.xs">
                  <IconButton
                    testId="dynamic-io-product-table-desktop-action"
                    icon="ChevronRight"
                    onPress={() => onPressItem(item)}
                    isDisabled={item.itemBlocked}
                    p={0}
                    backgroundColor="transparent"
                    iconColor={item.itemBlocked ? 'neutral.medium' : 'brand.tertiary.principal'}
                    iconSize="xs"
                  />
                </TableContentItemColumn>
              )}
            </TableContent>
          </Box>
        ))}
      </VStack>
    </VStack>
  );
};
